import { DialogUI } from '../../../Interface';
import { useSimpleTask } from '../../../../hooks/useSimpleTask';
import { useEffect, useState } from 'react';
import { SimpleTaskForm } from '../../../NewSimpleTask/SimpleTaskForm';

const SimpleTaskDialog = ({ open, handleClose, changed, task }) => {
  const { taskChanged, setTaskChanged } = changed;
  const simpleTaskState = useSimpleTask();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (task?.simpleTaskId) {
      simpleTaskState.setSelectedValues(task);
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, [task, simpleTaskState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={task?.simpleTaskId ? 'Feladat módosítása' : 'Új feladat létrehozása'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <div className="mt-5">
        <SimpleTaskForm
          dialog={{
            handleClose: handleClose,
            taskChanged: taskChanged,
            setTaskChanged: setTaskChanged,
            dialogData: task?.simpleTaskId ? {} : task,
            isUpdate: isUpdate,
          }}
          simpleTaskState={simpleTaskState}
        />
      </div>
    </DialogUI>
  );
};

export default SimpleTaskDialog;
